// extracted by mini-css-extract-plugin
module.exports = {"className":"mr-IN_className__mYATo"};